import { render } from "./PayBill.vue?vue&type=template&id=54f013fc&scoped=true"
import script from "./PayBill.vue?vue&type=script&lang=js"
export * from "./PayBill.vue?vue&type=script&lang=js"

import "./PayBill.vue?vue&type=style&index=0&id=54f013fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f013fc"]])

export default __exports__